import { render, staticRenderFns } from "./Carrinho.vue?vue&type=template&id=30e404aa&scoped=true"
import script from "./Carrinho.vue?vue&type=script&lang=js"
export * from "./Carrinho.vue?vue&type=script&lang=js"
import style0 from "./Carrinho.vue?vue&type=style&index=0&id=30e404aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e404aa",
  null
  
)

export default component.exports